exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3snNIlq3cRC3KhLdD3B0xj{display:flex}.cpNFBLHzfHCLsA8GTwb6N{flex:0 0 auto;padding-left:0.5em;padding-right:0.5em;margin-right:1em;border-radius:2px;background-color:#6982ff;color:#fafafa;font-size:12px;font-weight:500;cursor:pointer}.cpNFBLHzfHCLsA8GTwb6N ._1ObmHl2PYG_SvkCju4dhHC{margin-left:0.5em;font-weight:bold}\n", ""]);

// Exports
exports.locals = {
	"FiltersCrumbs": "_3snNIlq3cRC3KhLdD3B0xj",
	"Crumb": "cpNFBLHzfHCLsA8GTwb6N",
	"close": "_1ObmHl2PYG_SvkCju4dhHC"
};